import axios from 'axios';
import { hashTriibo1, validateRegistrationDate, generateRandom } from 'js/library/utils/helpers.js';
import cfac22 from '../cfac22';

export function getChannelTokenUidNull() {
  return new Promise((resolve, reject) => {
    //capturando dados do Storage
    const channelObj = JSON.parse(localStorage.getItem('channelTokenUidNull'));

    const valideDate = validateRegistrationDate(
      channelObj === null ? null : channelObj.registrationDate,
      15
    );

    //token não existe no storage
    if (
      channelObj === null ||
      channelObj.id === null ||
      channelObj.id === '' ||
      channelObj.id === undefined ||
      !valideDate
    ) {
      const passPhrase = generateRandom(10);
      const challenge = hashTriibo1(cfac22('apiToken'), passPhrase, cfac22('channeltoken'));

      axios
        .post(
          cfac22('API_HOST_V1') + 'getChannelToken_v1',
          {
            triiboHeader: {
              apiToken: cfac22('apiToken'),
              channelGroup: cfac22('channelGroup'),
              channelName: cfac22('channelName'),
              uId: null,
              passPhrase: passPhrase,
              challenge: challenge,
              channelId: cfac22('channelId'),
            },
          },
          {
            headers: {
              'Full-Url': window.location.href,
            },
          }
        )
        .then(() => {
          //console.log('RESULTADO GET CHANNEL TOKEN', result);
          localStorage.setItem(
            'channelTokenUidNull',
            '{ "id":"' + challenge + '", "registrationDate":' + Date.now() + '}'
          );

          resolve(challenge);
        })
        .catch((error) => {
          //console.log('ERRO GET CHANNEL TOKEN', error);
          reject(error);
        });
    }
    //token existe no storage
    else {
      resolve(channelObj.id);
    }
  });
}
